export const DROP_FLASH_MS = 700;

export function collectDescendantIds(node) {
  if (!node?.children?.length) return [];

  return node.children.flatMap((child) => [
    String(child.id),
    ...collectDescendantIds(child),
  ]);
}

export function findNodeById(nodes, id) {
  const target = String(id);
  for (const node of nodes || []) {
    if (String(node.id) === target) return node;
    const nested = findNodeById(node.children, id);
    if (nested) return nested;
  }
  return null;
}

export function isSameParent(left, right) {
  return String(left ?? '') === String(right ?? '');
}

export function shouldDimRow({
  activeId,
  activeParentId,
  rowId,
  rowParentId,
}) {
  if (!activeId) return false;
  if (String(rowId) === String(activeId)) return false;
  return !isSameParent(activeParentId, rowParentId);
}
